/**
 * Check if at date is between two dates
 */
export default function isBetween(a, x, b) {
  return a <= x && x <= b;
}
